module.exports = __webpack_public_path__ + "img/DITP-Photoroom.ac691c55.png";